import { Option } from '../../../general-types';
import { Flags, ValueOfKey } from '../../../utils-types';

export const SCAN_IQ_SUBSCRIPTIONS = {
  SCAN_IQ: 'SCAN_IQ',
  SCAN_IQ_SELF_BILLING: 'SCAN_IQ_SELF_BILLING',
} as const;

const NEW_FLOW_2024_SUBSCRIPTIONS = {
  REGULAR: 'REGULAR',
  REACTIVATION: 'REACTIVATION',
  FREE_ACCESS: 'FREE_ACCESS',
  SELF_BILLING: 'SELF_BILLING',
  ...SCAN_IQ_SUBSCRIPTIONS,
} as const;

export const SUBSCRIPTION = {
  SUPPLEMENT: 'SUPPLEMENT',
  NON_INBODY: 'NON_INBODY',
  NUTRITION: 'NUTRITION',
  SCHOLARSHIP: 'SCHOLARSHIP',
  CORPORATE: 'CORPORATE',
  SCHOLASTIC: 'SCHOLASTIC',
  ...NEW_FLOW_2024_SUBSCRIPTIONS,
} as const;

export const NON_PAID_SUBSCRIPTIONS = [
  SUBSCRIPTION.FREE_ACCESS,
  SUBSCRIPTION.SELF_BILLING,
  SUBSCRIPTION.SCAN_IQ_SELF_BILLING,
];

export type SubscriptionType = ValueOfKey<typeof SUBSCRIPTION>;
export type SubscriptionTypeFlags = Flags<SubscriptionType>;
export type NewFlow2024SubscriptionType = ValueOfKey<typeof NEW_FLOW_2024_SUBSCRIPTIONS>;
export type ScanIqSubscriptionType = ValueOfKey<typeof SCAN_IQ_SUBSCRIPTIONS>;

export const newFlow2024SubscriptionTypeOptions: Option<NewFlow2024SubscriptionType>[] = [
  { label: 'Regular', value: 'REGULAR' },
  { label: 'Reactivation', value: 'REACTIVATION' },
];

export const newFlow2024SubscriptionTypeOptionsWithAll: Option<
  NewFlow2024SubscriptionType | ''
>[] = [{ label: 'All Subscriptions', value: '' }, ...newFlow2024SubscriptionTypeOptions];
